import React, { useMemo } from "react";
import Select from "react-select";
import get from "lodash/get";

function ReactSingleSelect({
                               options,
                               placeholder = "Select...",
                               onChange,
                               value = [],
                               disabled = false,
                               errors,
                               name
}) {

    const errorMessage = get(errors, `${name}.message`);
    const handleChange = (option) => {
        if (onChange) {
            onChange(option);
        }
    };

    const formattedOptions = useMemo(() => {
        return options.map((item) => ({
            label: item.Label || item.Name || item.Text || "N/A",
            value: item.Value || item.Id,
        }));
    }, [options]);

    return (
        <div className="react-select-container">
            <Select
                value={value}
                onChange={handleChange}
                options={formattedOptions}
                placeholder={placeholder}
                classNamePrefix="react-select"
                isDisabled = {disabled}
            />
            {errorMessage && (
                <span className="fs-9 fw-bold text-danger">{errorMessage}</span>
            )}
        </div>
    );
}

export default ReactSingleSelect;
